// @flow

import type { PropsSchema, BasicProps, EasyAction } from '../../type'

import * as React from 'react'
import css from './Video.scss'
import onClickEvents from '../hoc/onClickEvent'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  videoUrl: string,
  onClick: () => void,
  image: ?{
    url: string,
    originWidth: number,
    originHeight: number
  },
  endIshowImage: boolean,
  children: React.ChildrenArray<React.Node>
};

type State = {
  playingVideo: boolean,
  videoLoading: boolean
};

@computeData({ includeData: true })
@onClickEvents
export default class Video extends React.PureComponent<Props, State> {
  static schema: PropsSchema = [
    {
      type: 'style'
    },
    'separator',
    {
      type: 'image'
    },
    {
      key: 'videoUrl',
      type: 'text',
      title: 'URL'
    },
    {
      key: 'endIshowImage',
      type: 'boolean',
      title: '播放后显示播放前图片'
    },
    'separator',
    {
      type: 'event',
      title: '播放事件',
      event: 'play'
    },
    {
      type: 'event',
      title: '暂停事件',
      event: 'pause'
    },
    {
      type: 'event',
      title: '结束事件',
      event: 'ended'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '播放',
      name: 'play'
    }
  ];

  state = { playingVideo: false, videoLoading: false };

  canPlayVideo = false;

  actionPlay = () => {
    this.playVideo()
  };

  getVideoElement () {
    return this.refs.video
  }

  componentDidMount () {
    let { callActions } = this.props
    let video = this.getVideoElement()

    this.canPlayVideo = false

    video.addEventListener(
      'canplaythrough',
      () => {
        this.canPlayVideo = true
      },
      false
    )
    video.addEventListener('play', () => {
      callActions('play')
    })
    video.addEventListener('pause', () => {
      callActions('pause')
    })
    video.addEventListener('ended', () => {
      if (this.props.endIshowImage) {
        this.setState({ playingVideo: false })
      }
      callActions('ended')
    })
  }

  playVideo = () => {
    let video = this.refs.video
    this.setState({
      playingVideo: true
    })
    if (video.paused) {
      if (this.canPlayVideo) {
        this.setState({
          videoLoading: false
        })
      }
      video.play()
    } else {
      video.pause()
    }
  };

  render () {
    const { id, style, onClick, visible, jsEnv, image, videoUrl } = this.props
    let { playingVideo, videoLoading } = this.state
    if (!visible) {
      return null
    }
    const imgUrl = image && image.url
    const videoUrlString = videoUrl
      ? jsEnv.getString(videoUrl)
      : jsEnv.runCode('videoUrl')
    return (
      <div className={css.main} style={style} id={id} onClick={onClick}>
        <div style={{ lineHeight: 0, height: '100%' }}>
          <video
            ref='video'
            webkit-playsinline=''
            playsinline=''
            x5-playsinline='true'
            x-webkit-airplay='true'
            preload='auto'
            src={videoUrlString}
            className={playingVideo && videoUrlString ? css.video : 'hide'}
            autoPlay={false}
            controls='controls'
            x5-video-player-type='h5-page'
            x5-video-player-fullscreen='true'
            style={{
              width: '100%',
              verticalAlign: 'middle',
              ...(style.height ? { height: '100%' } : {})
            }}
          />
          {!playingVideo && imgUrl && (
            <img src={imgUrl} className={css.image} onClick={this.playVideo} />
          )}
          {videoLoading && <div className={css.loading}>加载中...</div>}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Video.js